export const blogCategories = [
  { id: "peb", name: "PEB" },
  { id: "industrial-sheds", name: "Industrial Sheds" },
  { id: "warehouses", name: "Warehouses" },
  { id: "steel-fabrication", name: "Steel Fabrication" },
  { id: "cost-guides", name: "Construction & Cost Guides" },
  { id: "engineering", name: "Engineering" },
];

export const getCategoryName = (id) => blogCategories.find((c) => c.id === id)?.name || id;
